import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';

const CrearPersonal = () => {
  const [formData, setFormData] = useState({
    Rut: '',
    Nombre: '',
    CentroCosto: '',
    NombreEmpresa: '',
    AreaTrabajo: '',
    RutEmpresa: ''
  });
function formatearRut(rut) {
  rut = rut.replace(/[^0-9kK]/g, ''); // Solo permite números y la K o k
  if (rut.length < 2) return rut;

  const cuerpo = rut.slice(0, -1);
  let dv = rut.slice(-1).toUpperCase(); // Siempre en mayúscula

  // Insertar puntos cada tres dígitos
  let cuerpoConPuntos = '';
  let contador = 0;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    cuerpoConPuntos = cuerpo[i] + cuerpoConPuntos;
    contador++;
    if (contador % 3 === 0 && i !== 0) {
      cuerpoConPuntos = '.' + cuerpoConPuntos;
    }
  }

  return `${cuerpoConPuntos}-${dv}`;
}
  const [mensaje, setMensaje] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post('https://casinop2.sanjoseapps.cl/api/crear-personal.php', formData)
      .then(res => {
            if (res.data.error) {
            alert(res.data.error); // Aquí avisas del RUT duplicado
            } else {
            alert('Personal creado exitosamente'); 
        setFormData({
          Rut: '',
          Nombre: '',
          CentroCosto: '',
          NombreEmpresa: '',
          AreaTrabajo: '',
          RutEmpresa: ''
        });
        }
      })
      .catch(err => {
        setMensaje('Error al crear personal');
      });
  };

  return (
    <>
      <Navbar />
  <section className="section">
  <div className="container">
    <h1 className="title">Crear Personal</h1>
    {mensaje && <div className="notification is-info">{mensaje}</div>}
    <form onSubmit={handleSubmit} className="box">
      {['Rut', 'Nombre', 'CentroCosto', 'NombreEmpresa', 'AreaTrabajo', 'RutEmpresa'].map((campo) => (
        <div className="field" key={campo}>
          <label className="label">{campo}</label>
          <div className="control">
            <input
              className="input"
              type="text"
              name={campo}
              value={formData[campo]}
              onChange={handleChange}
              onBlur={(e) => {
                if (campo.toLowerCase().includes('rut')) {
                  const formateado = formatearRut(e.target.value);
                  setFormData((prev) => ({ ...prev, [campo]: formateado }));
                }
              }}maxLength={undefined}
              required
            />
          </div>
        </div>
      ))}
      <div className="field">
        <div className="control">
          <button type="submit" className="button is-primary">Crear</button>
        </div>
      </div>
    </form>
  </div>
</section>


    </>
  );
};

export default CrearPersonal;